import { jsx as _jsx } from "react/jsx-runtime";
import { useI18n } from "@/shared/hooks";
import { Box } from "@gemini/core";
import { Modal } from "@gemini/ui";
export const TagInfoModal = ({ isOpen, toggle }) => {
    const { t } = useI18n();
    const testId = "tag-info-modal";
    const legalText = t("tags.hd_exclusivity.legal.text")
        .replace("{immoweltLink}", `<a target="_blank" href="${"https://www.immowelt.de/"}">${"immowelt.de"}</a>`)
        .replace("{immonetLink}", `<a target="_blank" href="${"https://www.immonet.de/"}">${"immonet.de"}</a>`);
    const onModalClick = (e) => {
        e.stopPropagation();
    };
    return (_jsx(Modal, { testId: testId, isDismissable: true, trigger: () => null, isOpen: isOpen, onOpenChange: toggle, 
        // @ts-ignore
        onClick: onModalClick, children: _jsx(Box, { as: "span", typography: "typography.body.14.regular", dangerouslySetInnerHTML: { __html: legalText }, onClick: onModalClick }) }));
};
